import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import LoaderGif from "../../Assets/AppComponent/Loadergif.webp";
export default function CircularIndeterminate() {
  return (
    <>
      <div

        className="MainLoader"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          // backgroundColor: "rgba(0, 0, 0, 0.4)",
          zIndex: 999999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          // backdropFilter: "blur(2px)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "200px",
            height: "175px",
            backgroundColor: "white",
            boxShadow: " rgba(0, 0, 0, 0.35) 0px 5px 15px",
            borderRadius: "3px",
            zIndex: 9999,
            // position: "absolute",
            // top: "37%",
            // left: "42%",
          }}
        >
          <div>
            <p style={{ margin: 10, textAlign: "center", fontSize: "12px" }}>
              Loading...
            </p>
          </div>
          <CircularProgress
            sx={{
              width: "87px !important",
              height: "87px !important",
              margin: "auto",
              color: "#F26A38",
            }}
          />
        </Box>

        {/* <div className="" style={{width:"100px", height:"100px"}}>

        <img src={LoaderGif} style={{width:"100%", height:"100%"}}/>
      </div> */}
      </div>
    </>
  );
}